<template>
  <v-bottom-sheet :value="getAlerta" inset hide-overlay>
    <v-sheet class="text-center">
    <p style="padding: 30px 0!important" class="subtitle-1">{{ $t(getTextoAlerta) }}</p>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'app-alerta',
  computed: {
    ...mapGetters(['getAlerta', 'getTextoAlerta', 'getDialog'])
  },
  methods: {
    ...mapMutations(['setAlerta']),
    cerrar () {
      this.setAlerta()
    },
    testAlert () {
      console.log('Cambio el alert')
    }
  },
  beforeDestroy () {
    console.log('Cambio el alert DEs')
  },
  beforeUpdate () {
    console.log('Cambio el alert beforeUpdate')
  },
  deactivated () {
    console.log('Cambio el alert deac')
  }

}
</script>

<style>
.v-application p {
  margin-bottom: 0!important;
}
</style>
